import React, { useRef } from 'react';
import Link from './Link';

import useIntersection from 'buena-suerte/lib/hooks/useIntersection';
import classNames from 'classnames';

export default ({
  leftImage,
  leftTitle,
  leftLink,
  rightImage,
  rightTitle,
  rightLink,
}) => {
  const intersectionRef = useRef();
  const isIntersected = useIntersection(intersectionRef);

  return (
    <section
      ref={intersectionRef}
      className={classNames('df fdc fdr--lg bb--dark-brown reveal', {
        revealed: isIntersected,
      })}
    >
      <div className="image-panel image-panel--left x br--dark-brown--lg pr">
        <Link {...leftLink}>
          <picture>
            <source
              srcSet={`${leftImage.url}?w=1200&auto=format&q=100`}
              media="(min-width: 1000px)"
            />
            <source
              srcSet={`${leftImage.url}?w=600&auto=format&q=100`}
              media="(min-width: 600px)"
            />
            <img
              alt={leftImage.alt}
              className="db"
              src={`${leftImage.url}?w=600&auto=format&q=100`}
            />
          </picture>
          <div className="image-panel__title p2 pa">
            <p className="serif--sm serif--md--md">{leftTitle}</p>
            <div className="df pt1 aic">
              <div
                className="circle mr1"
                style={{ backgroundColor: 'currentcolor' }}
              />{' '}
              <p className="uppercase">{leftLink.title}</p>
            </div>
          </div>
        </Link>
      </div>
      <div className="image-panel x  pr">
        <Link {...rightLink}>
          <picture>
            <source
              srcSet={`${rightImage.url}?w=1200&auto=format&q=100`}
              media="(min-width: 1000px)"
            />
            <source
              srcSet={`${rightImage.url}?w=600&auto=format&q=100`}
              media="(min-width: 600px)"
            />
            <img
              alt={rightImage.alt}
              className="db"
              src={`${rightImage.url}?w=600&auto=format&q=100`}
            />
          </picture>
          <div className="image-panel__title p2 pa">
            <p className="serif--sm serif--md--md">{rightTitle}</p>
            <div className="df pt1 aic">
              <div
                className="circle mr1"
                style={{ backgroundColor: 'currentcolor' }}
              />{' '}
              <p className="uppercase">{rightLink.title}</p>
            </div>
          </div>
        </Link>
      </div>
    </section>
  );
};
